export default __webpack_public_path__ + "static/media/Partners.22fc8508.png";